import {Navigate} from 'react-router-dom';
import React from 'react';
import {mapRoleToProps, mapRoleToPropsType} from '../../../redux/entities/user';
import {connect} from 'react-redux';
import {useLocation} from 'react-router-dom';
import {RoutePaths} from '../../../router/RoutePaths';

type RoleProtectedRouteProps = mapRoleToPropsType & {
  children: JSX.Element;
  allowedRoles: string[];
};

const RoleProtectedRouteComponent = ({children, roleName, allowedRoles}: RoleProtectedRouteProps) => {
  const location = useLocation();
  return (
    allowedRoles.includes(roleName) ? children : (
      <Navigate to={RoutePaths.privatePaths.home} state={{ from: location }} replace={true}/>
    )
  );
};

export const RoleProtectedRoute = connect(mapRoleToProps)(RoleProtectedRouteComponent);
